/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdStickyProps } from './type';

export const stickyDefaultProps: TdStickyProps = { container: 'body', disabled: false, offsetTop: 0, zIndex: 99 };
